
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "../../types";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { HOSTING_STYLES } from "../../constants/hostingStyles";
import { useToast } from "@/hooks/use-toast";
import { Badge } from "@/components/ui/badge";

interface HostingStyleFieldProps {
  form: UseFormReturn<ProfileFormData>;
}

export const HostingStyleField = ({ form }: HostingStyleFieldProps) => {
  const { toast } = useToast();

  const handleValueChange = (values: string[]) => {
    try {
      form.setValue('hosting_style', values, {
        shouldValidate: true,
        shouldDirty: true
      });
    } catch (error) {
      console.error("Error updating hosting styles:", error);
      toast({
        title: "Error",
        description: "Failed to update hosting styles. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <FormField
      control={form.control}
      name="hosting_style"
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>Hosting Style</FormLabel>
          <FormControl>
            <div className="space-y-4">
              <ToggleGroup
                type="multiple"
                variant="outline"
                className="flex flex-wrap gap-2"
                value={field.value}
                onValueChange={handleValueChange}
              >
                {HOSTING_STYLES.map((style) => (
                  <ToggleGroupItem
                    key={style}
                    value={style}
                    variant="outline"
                    className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
                  >
                    {style}
                  </ToggleGroupItem>
                ))}
              </ToggleGroup>
              
              {/* Preview of selected hosting styles */}
              {field.value && field.value.length > 0 && (
                <div className="mt-2">
                  <p className="text-sm text-muted-foreground mb-2">Selected styles:</p>
                  <div className="flex flex-wrap gap-2">
                    {field.value.map((style) => (
                      <Badge key={style} variant="secondary">
                        {style}
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
